import { axiosRequest, axiosAuthenticatedRequest } from './axios';

export const obtainToken = async (data: AuthCredentialsType) => {
  const res = await axiosRequest.post<AuthTokenType>(
    '/customers/auth/obtain_jwt_from_email_token/',
    data
  );
  return res.data;
};

export const obtainAuthenticationEmail = async (
  data: AuthEmailCredentialsType
) => {
  const res = await axiosRequest.post('/customers/auth/email_login/', data);
  return res.data;
};

export const guestLogin = async (data: GuestAuthCredentialsType) => {
  const res = await axiosRequest.post('/customers/auth/guest_login/', data);
  return res.data;
};

export const getAuthUser = async (): Promise<AuthUserType> => {
  const res = await axiosAuthenticatedRequest.get('/customers/auth/me/');
  return res.data;
};
